module.exports = __webpack_public_path__ + "img/horizontal_3_7_pp2_8003.c173623a.png";